import { Box, Flex } from '@chakra-ui/react'

import ScrollContainer from 'src/components/widgets/ScrollContainer/ScrollContainer'

import useSmall from './useSmall'

const Small = (props: {
  children: React.ReactNode | React.ReactNode[]
  itemWidth: number
  gap?: number
  margin?: number
  outerPadding?: number
  startWithItem?: number
}) => {
  const { containerWidth, scrollContainer, items } = useSmall(props)
  return (
    <ScrollContainer margin={props.margin} ref={scrollContainer}>
      <Flex
        px={props.outerPadding}
        w={containerWidth}
        overflowX="auto"
        gap={props.gap}
      >
        {items.map((item, i) => (
          <Box w={props.itemWidth} key={i}>
            {item}
          </Box>
        ))}
      </Flex>
    </ScrollContainer>
  )
}

export default Small
